/**
 * صورة تُقدَّم بصيغة WebP مع بديل PNG.
 *
 * كانت الصور تُدرَج بـ <img src={png}> مباشرة. مثال واحد يوضّح الكلفة:
 * صورة قسم «لماذا الأكاديمية» كانت 979 كيلوبايت بمقاس 1104×1472، وتُعرض
 * بارتفاع أقصاه 500 بكسل — أي أن الزائر يحمّل عشرين ضعف ما يراه. بصيغة
 * WebP وبمقاس مناسب صارت 27 كيلوبايت.
 *
 * <picture> تُبقي البديل قائمًا: المتصفح الذي لا يدعم WebP يأخذ الـ PNG
 * دون أي كود إضافي.
 *
 * width و height إلزاميان: بدونهما لا يعرف المتصفح المساحة التي ستشغلها
 * الصورة، فيقفز التخطيط لحظة تحميلها.
 */
const Picture = ({ webp, fallback, alt, width, height, className = "", loading = "lazy" }) => (
  <picture>
    <source srcSet={webp} type="image/webp" />
    <img
      src={fallback}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding="async"
      className={className}
    />
  </picture>
);

export default Picture;
